// Module
var code = "<textarea-field v-if=\"form\" :disabled=\"disabled\" :label=\"label ? label : name\" :placeholder=\"placeholder\" :value.sync=\"form[field]\" :rows=\"rows\" :enableAutosize=\"enableAutosize\" @change=\"onChange()\" @keyup=\"onKeyUp()\" :validation=\"form.validation[field]\"><slot>{{ label || name }}</slot> </textarea-field> ";
// Exports
export default code;